var map = {
	"./amazon.png": 2125,
	"./bharatPe.png": 86404,
	"./bhim.png": 70229,
	"./freecharge.png": 30119,
	"./gPay1.png": 28421,
	"./gPay2.png": 25998,
	"./india.png": 99716,
	"./indiaF.png": 52440,
	"./indiaM.png": 46923,
	"./mobiKwik1.png": 56419,
	"./mobiKwik2.png": 19560,
	"./paytm.png": 58654,
	"./phonePe.png": 91608,
	"./upi.png": 75429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71206;